import { Navigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import Dashboard from "./Dashboard";
import LabDashboard from "./LabDashboard";
import AssessorDashboard from "./AssessorDashboard";

const RoleBasedDashboard = () => {
  const { user } = useAuth(); // userRole comes from JWT/context/backend
  switch (user?.role) {
    case "LABORATORY":
      return <LabDashboard />;
    case "ASSESSOR":
      return <AssessorDashboard />;
    case "MINISTRY":
      return <Dashboard />;
    case "OWNER":
      return <Dashboard />;
    default:
      return <Navigate to="/not-authorized" replace />;
  }
}

export default RoleBasedDashboard